var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { computed, observable, reaction } from "mobx";
import { UserType } from "healthex-common/user.dtos";
import { asEnum } from "healthex-common/utils";
import { i18nGetCurrentLanguage, i18nSetLanguage } from "../Infra/i18next";
import { NamedRoutes } from "./NamedRoutes";
import { StudyTranslationLanguage } from "healthex-common/study-translation-language.dtos";
export class BrowserLanguageUIManager {
    constructor(authManager, persistence, routingUIManager) {
        this.authManager = authManager;
        this.persistence = persistence;
        this.routingUIManager = routingUIManager;
        this.inMemoryLanguage = null;
        this.persistentLanguage = null;
        this.setPersistentLanguage(this.persistence.getLanguage());
        reaction(() => this.selectedLanguage, async () => {
            await this.changeI18NextLanguage();
        }, { fireImmediately: true });
    }
    get browserLanguage() {
        const language = window.navigator.language.split("-")[0];
        return asEnum(StudyTranslationLanguage)(language);
    }
    get isGuidedConsentFlow() {
        const currentRoute = this.routingUIManager.currentRoute;
        return (currentRoute === null || currentRoute === void 0 ? void 0 : currentRoute.routeName) === NamedRoutes.GUIDED_PATIENT_CONSENT_ENROLLMENT.routeName;
    }
    get translationsNotAvailable() {
        const isProviderInGuidedConsent = this.authManager.isProvider && this.isGuidedConsentFlow;
        return (this.authManager.isLoggedIn &&
            (this.authManager.userType !== UserType.PATIENT || this.authManager.isProvider) &&
            !isProviderInGuidedConsent);
    }
    get selectedLanguage() {
        var _a, _b, _c;
        if (this.translationsNotAvailable)
            return StudyTranslationLanguage.en;
        return (_c = (_b = (_a = this.inMemoryLanguage) !== null && _a !== void 0 ? _a : this.persistentLanguage) !== null && _b !== void 0 ? _b : this.browserLanguage) !== null && _c !== void 0 ? _c : StudyTranslationLanguage.en;
    }
    get currentLanguage() {
        var _a;
        const currentLanguageString = i18nGetCurrentLanguage();
        return (_a = asEnum(StudyTranslationLanguage)(currentLanguageString)) !== null && _a !== void 0 ? _a : StudyTranslationLanguage.en;
    }
    async changeI18NextLanguage() {
        await i18nSetLanguage(this.selectedLanguage);
    }
    setInMemoryLanguage(language) {
        this.inMemoryLanguage = language;
    }
    getInMemoryLanguage() {
        return this.inMemoryLanguage;
    }
    setPersistentLanguage(language) {
        this.persistentLanguage = language;
        this.persistence.setLanguage(language);
    }
}
__decorate([
    observable,
    __metadata("design:type", Object)
], BrowserLanguageUIManager.prototype, "inMemoryLanguage", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], BrowserLanguageUIManager.prototype, "persistentLanguage", void 0);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], BrowserLanguageUIManager.prototype, "isGuidedConsentFlow", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], BrowserLanguageUIManager.prototype, "translationsNotAvailable", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], BrowserLanguageUIManager.prototype, "selectedLanguage", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], BrowserLanguageUIManager.prototype, "currentLanguage", null);
